import { useCallback, useEffect, useState } from "react";
import { _AccountINFORPO, _Affiliate, _CreditAccount, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage"
import useModal, { MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import usePaginator from "../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ThirdCreditsInforpoDetails } from "./ThirdCreditsInforpoDetails";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../theme/Component/DropDown";
import { BasicButton } from "../../../theme/Component/BasicButton";

export const ThirdCreditsInforpo = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AccountINFORPO);
    const afiliate = useDataBean(_Affiliate);
    const _credit = useDataBean(_CreditAccount);
    const modalDetails = useModal("Detalles del Credito", MODAL_XL);
    const paginador = usePaginator();
    const [idAccount, setIDAccount] = useState<number>();
    const [nit, setNit] = useState<number>();
    const [client, setClient] = useState<number>();

    const getLista = useCallback(() => {


        if (nit)
            getAffiliate();

    }, [nit])
    useEffect(() => {
        if (client)
            getCredit(client);
    }, [client])

    const getAffiliate = () => {
        console.log("Buscando Nit => " + nit);

        const Props = { NUMERO_IDENTIFICACION: nit };
        afiliate.instance.getAffiliateInforpo(1, 15, Props).then(
            (resp: any) => {                
                if (resp.List) {
                    let acc = resp.List;                    
                    getCredit(acc[0].DataBeanProperties.CLIENTE_ID);
                    setClient(acc[0].DataBeanProperties.CLIENTE_ID)
                } else {
                    toast.error("No se encontraron datos del usuario");
                }
            }).catch(err => {
                console.error(err);
                toast.error("Error al cargar la información del usuario");
            });
    };

    const getCredit = (idCLient?: number) => {
        const prop = {
            CLIENTE_ID: idCLient
        }
        instance.getCreditAffiliateInforpo(paginador.page, 15, prop).then(
            (data: any) => {
                data.List.forEach(creditos => {
                    const credito = creditos.DataBeanProperties;
                    credito.RenderState = `${returnEstado(credito.ESTADO_CREDITO_ID)?.label ?? "N/A"}`
                });
                setLista(data.List);
                paginador.setPages(data.NumberOfPages);
            }
        ).catch((error: any) => {
            toast.error(error);
        })
    }

    const estados = {
        725: { label: 'Cancelado', color: 'bg-danger' },
        724: { label: 'Vigente', color: 'bg-primary' },
        723: { label: 'Aprobado', color: 'bg-success' },
    };

    const returnEstado = (id) => estados[id] ?? { label: 'No encontrado', color: 'bg-secondary' };

    const head = [
        { title: 'Numero de Crédito', property: 'NUMERO_CREDITO', visible: true, mask: MASK_NUMBER },
        { title: 'Monto', property: 'MONTO_CREDITO', visible: true, mask: MASK_MONEY },
        { title: 'Saldo', property: 'SALDO_CREDITO', visible: true, mask: MASK_MONEY },
        { title: 'Fecha de Aprobación', property: 'FECHA_APROBACION', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Cancelación', property: 'FECHA_CANCELACION', visible: false, mask: MASK_DATE },
        { title: 'Fecha de Modificación', property: 'FECHA_MODIFICACION', visible: false, mask: MASK_DATE },
        { title: 'Fecha del Crédito', property: 'FECHA_CREDITO', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Creación', property: 'FECHA_CREACION', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Desembolso', property: 'FECHA_DESEMBOLSO', visible: true, mask: MASK_DATE },
        { title: 'Fecha de Saldo', property: 'FECHA_SALDO', visible: true, mask: MASK_DATE },
        { title: 'Estado', property: 'RenderState', visible: true },
        { title: 'Observaciones', property: 'OBSERVACIONES', visible: true },
        { title: 'Comentarios', property: 'COMENTARIOS', visible: false },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Detalles', icono: 'ri-list-check', visible: true, evento: () => { modalDetails.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [listaExport, setListaExport] = useState([]);

    const getListaExport = () => {
        // functionalArea.instance.getFunctionalAreaCatalogvdos(IDLn, formResponse.State, formResponse.Name, formResponse.IDLnFunctional, formResponse.Appointment, formResponse.StateContract, formResponse.IDAccount, date, 1, paginador.pages * 15).then(
        const prop = {
            CLIENTE_ID: client
        }
        instance.getCreditAffiliateInforpo(1, paginador.pages * 15, prop).then(
            (data: any) => {
                data.List.forEach(creditos => {
                    const credito = creditos.DataBeanProperties;
                    credito.RenderState = `${returnEstado(credito.ESTADO_CREDITO_ID)?.label ?? "N/A"}`
                });
                setListaExport(data.List);
            }
        ).catch((error: any) => {
            toast.error(error);
        })
    }

    const modalcsv = useModal("Exportar Listado", MODAL_SM)

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                </div>
            </div>
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 2, name: 'Sincronizar Usuario', permiso: null, activo: true },
    ];


    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            modalcsv.open();
        }
        else if (e.id === 2) {

            _credit.instance.recrearCreditoByListSerial(_single.getAccountID(), JSON.stringify([["IDENTIFICACION"], [nit]]), ["german.paez@advantage.com.co"]).then(
                (resp: any) => {
                    toast.success("Se inicio la sincronizacion de la cuenta");
                    console.log(resp);
                    
                }
            )
        }
    }


    return (
        <BasicPage titulo="Creditos de Tercero (Inforpo)" >
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={idAccount} label="Tercero" onChange={(e) => { setIDAccount(e.IDAccount); setNit(parseInt(e.Nit)) }} />
                    <BasicButton icon="" eventClick={getLista} useMargin>Buscar</BasicButton>
                </div>
            </div>
            <BasicTable headButtons={buttons()} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

            <Modal modal={modalDetails.modal} updateModal={modalDetails.setModal} >
                <ThirdCreditsInforpoDetails Credit={bean} />
            </Modal>

            <Modal modal={modalcsv.modal} updateModal={modalcsv.setModal}>
                <div className="row">
                    <div className="col">
                        {lista.length > 0 &&
                            <ExportXLSL customName={`Creditos`} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}